import { MeasureDataTableFilters } from "store/types";

export const defaultMeasureDataTableFilters: MeasureDataTableFilters = {
  deals: [],
  accountingDate: null,
  effectiveDate: null,
  createdAtDate: null,
  enteredByDate: null,
  measures: [],
  investors: [],
  // rounds: [],
  enteredBy: [],
  calculatedFields: [], // Should be calc field keys
  lastTransactions: false,
  hideDeleted: true
};
